<template>
  <!-- 健康体检报告  -->
  <div v-if="model && model.phccloud">
    <div id="print_phccloud" class="page phccloud-page">
      <div style="display: flex;font-size: 30px;text-align: center;font-weight: 600;">
        <table style="width: 100%;border-collapse: collapse;border:none;letter-spacing: 5px;">
          <tbody>
            <tr style="width: 100%;border-collapse: collapse;border:none;">
              <td style="border-collapse: collapse;border:none;">{{ model.phccloud.reportName ? model.phccloud.reportName : "健康体检报告" }}</td>
            </tr>
          </tbody>
        </table>
        <div>
          <div>
            <img :src="model.phccloud.barCodeImage" style="width: 100%; height: 100%;"/>
          </div>
          <div style="line-height: 0px;font-size: 15px;letter-spacing: 0px;" v-if="model.phccloud.barCodeImage">{{model.phccloud.barCode}}</div>
        </div>
      </div>

      <table style="padding-left: 10px;text-align: left;width: 100%;margin-top:10px;border-collapse: collapse;border:none;">
        <tbody>
          <tr style="line-height: 30px;border:none;">
            <td colspan="5" style="width: 65%;border-collapse: collapse;border:none;">学校：<span>{{model.phccloud.schoolName ? model.phccloud.schoolName : ""}}</span></td>
            <td colspan="2" tyle="width: 100px;border-collapse: collapse;border:none;">检查日期：<span>{{model.phccloud.checkDate ? model.phccloud.checkDate : ""}}</span></td>
          </tr>
          <tr style="line-height: 30px;width: 100px;border:none;">
            <td colspan="5" style="width: 65%;border-collapse: collapse;border:none;">班级：<span>{{model.phccloud.className ? model.phccloud.className : ""}}</span></td>
          </tr>
        </tbody>
      </table>

      <table style="text-align: center;width: 100%;border-collapse: collapse;border: 1px solid black;">
        <tbody>
        <tr style="line-height: 30px;">
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">姓名</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.name ? model.phccloud.name : ""}}</span></td>
          <td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;">性别</td><td style="width: 70px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.sex ? model.phccloud.sex : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">出生日期</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.birthday ? model.phccloud.birthday : ""}}</span></td>
          <td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;">民族</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.nation ? model.nation : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">联系电话</td><td colspan="2" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.phone ? model.phccloud.phone : ""}}</span></td>
          <td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;">身份证号</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.idcard ? model.phccloud.idcard : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;"><td style="width: 70px;border-collapse: collapse;border: 1px solid black;">既往病史</td><td colspan="5" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.pastMedicalHistory ? model.phccloud.pastMedicalHistory : ""}}</span></td></tr>
        <tr style="line-height: 30px;">
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">过敏史</td><td colspan="5" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.allergyHistory ? model.phccloud.allergyHistory : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">家族史</td><td colspan="5" style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.familyHistory ? model.phccloud.familyHistory : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td rowspan="3" style="width: 70px;border-collapse: collapse;border: 1px solid black;">一般情况</td>
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">身高</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.height ? model.phccloud.height : ""}}</span><span style="float:right;margin-right: 15px">cm</span></td>
          <td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;">体重</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.weight ? model.phccloud.weight : ""}}</span><span style="float:right;margin-right: 15px">kg</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">BMI</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.bmi ? model.phccloud.bmi : ""}}</span></td>
          <td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;">血压</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.systolicPressure ? model.phccloud.systolicPressure : ""}}</span>/<span>{{model.phccloud.diastolicPressure ? model.phccloud.diastolicPressure : ""}}</span><span style="float:right;margin-right: 15px">mmHg</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">脉搏</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.pulse ? model.phccloud.pulse : ""}}</span><span style="float:right;margin-right: 15px">次/分</span></td>
          <td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;">肺活量</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.vitalCapacity ? model.phccloud.vitalCapacity : ""}}</span><span style="float:right;margin-right: 15px">ml</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td rowspan="2" style="width: 70px;border-collapse: collapse;border: 1px solid black;">裸眼视力</td>
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">左</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.nakedLeftEyeVision ? model.phccloud.nakedLeftEyeVision : ""}}</span></td>
          <td rowspan="2" style="width: 45px;">矫正视力</td>
          <td style="width: 15px;border-collapse: collapse;border: 1px solid black;">左</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.correctLeftEyeVision ? model.phccloud.correctLeftEyeVision : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">右</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.nakedRightEyeVision ? model.phccloud.nakedRightEyeVision : ""}}</span></td>
          <td style="width: 15px;border-collapse: collapse;border: 1px solid black;">右</td><td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.correctRightEyeVision ? model.phccloud.correctRightEyeVision : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td rowspan="4" style="width: 70px;border-collapse: collapse;border: 1px solid black;">五官科</td>
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">眼底</td><td style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.fundus ? model.phccloud.fundus : ""}}</span></td>
          <td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;">听力</td><td style=" width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.hearing ? model.phccloud.hearing : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">咽喉</td><td style=" width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.pharynx ? model.phccloud.pharynx : ""}}</span></td>
          <td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;">口腔</td><td style=" width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.oralCavity ? model.phccloud.oralCavity : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">辨色力</td><td colspan="4" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.distinguishColour ? model.phccloud.distinguishColour : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 50px;border-collapse: collapse;border: 1px solid black;">其他</td><td colspan="4" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.facialFeaturesOther ? model.phccloud.facialFeaturesOther : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td rowspan="5" style="width: 70px;border-collapse: collapse;border: 1px solid black;">内科</td>
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">营养发育</td><td style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.development ? model.phccloud.development : ""}}</span></td>
          <td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;">神经精神</td><td style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.neuropsychology ? model.phccloud.neuropsychology : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">呼吸系统</td><td style=" width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.systemBreathing ? model.phccloud.systemBreathing : ""}}</span></td>
          <td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;">循环系统</td><td style=" width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.systemLoop ? model.phccloud.systemLoop : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">肝胆</td><td style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.liverAndGallbladder ? model.phccloud.liverAndGallbladder : ""}}</span></td>
          <td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;">脾脏</td><td style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.spleen ? model.phccloud.spleen : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">肾脏</td><td colspan="4" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.kidney ? model.phccloud.kidney : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">其他</td><td colspan="4" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.insideOther ? model.phccloud.insideOther : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td rowspan="4" style="width: 70px;border-collapse: collapse;border: 1px solid black;">外科</td>
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">皮肤</td><td style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.skin ? model.phccloud.skin : ""}}</span></td>
          <td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;">淋巴</td><td style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.lymph ? model.phccloud.lymph : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">甲状腺</td><td style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.thyroid ? model.phccloud.thyroid : ""}}</span></td>
          <td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;">脊椎</td><td style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.spine ? model.phccloud.spine : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">四肢</td><td style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.limb ? model.phccloud.limb : ""}}</span></td>
          <td colspan="2" style="width: 50px;border-collapse: collapse;border: 1px solid black;">关节</td><td style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.joint ? model.phccloud.joint : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 70px;border-collapse: collapse;border: 1px solid black;">其他</td><td colspan="4" style="width: 50px;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.surgeryOther ? model.phccloud.surgeryOther : ""}}</span></td>
        </tr>
        <tr style="line-height: 30px;">
          <td style="width: 70px;height: 110px;border-collapse: collapse;border: 1px solid black;">检查结论</td>
          <td colspan="2" style="width: 100px;word-wrap: break-word;overflow: auto;flex-wrap: wrap;justify-content: flex-start;border-collapse: collapse;border: 1px solid black;"><span>{{model.phccloud.inspectionResults ? model.phccloud.inspectionResults : ""}}</span></td>
          <td colspan="2" style="width: 50px;height: 110px;border-collapse: collapse;border: 1px solid black;">医师签名</td>
          <td style="width: 100px;border-collapse: collapse;border: 1px solid black;"><img :src="model.phccloud.doctorSignature" style="height: 40px;width: 100px;object-fit: contain;" v-if="model.phccloud.doctorSignature"></td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>

import {_phccloud} from "@/services/report/report";
export default {
  name: "phccloudReport",
  props: {
    physicalId: [String, Number],
    barCode: [String, Number],
    reportCode: [String],
    printData: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      model: {
        phccloud:{
          reportName: "",
          hospitalName: "",
          name: "",
        }
      },
    };
  },
  watch:{
    reportCode:{
      handler(newVal,oldVal){
        if(newVal === 'phccloud'){
          this.loadData();
        }
      }
    },
    printData: {
      handler(newVal) {
        if (newVal && this.reportCode === 'phccloud') {
          this.model = newVal;
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  onLoad() {
    console.log("onLoad")
  },
  onUnLoad(){
    console.log("onUnLoad")
  },
  onReady () {
    console.log("onReady")
  },
  methods: {
    loadData(){
      if(this.barCode){
        this.phccloud(this.barCode);
      }
    },
    /*createBarCode() {
      JsBarcode("#barcode", this.barCode, {
        format: "CODE128",      // 条码类型
        height: 45,             // 条码高度
        width: 1.3,             // 单条宽度
        displayValue: true,     // 显示下方文本
        text: this.barCode,     // 自定义文本（与条码值一致）
        fontSize: 16,           // 文本大小
        textAlign: "center",    // 文本居中
        lineColor: "#000000",   // 条码颜色
        margin: 5              // 条码外间距
      });
    },*/
    phccloud(barCode) {
      _phccloud({barCode: barCode}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.$emit('on-setReportData', res.data);
        this.model = res.data;
        /*if(this.model.phccloud.barCodeImage){
            this.drawBase64ToCanvas(this.model.phccloud.barCodeImage);
        }*/
      })
    },
    drawBase64ToCanvas (base64String) {
      const canvas = this.$refs.barcodeImage;
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        // 设置Canvas尺寸与图片一致
        canvas.width = img.width;
        canvas.height = img.height;
        // 绘制图片
        ctx.drawImage(img, 0, 0);
      };

      img.onerror = () => console.error("图片加载失败");
      img.src = base64String;
    }
  }
}
</script>
<style lang="postcss" scoped>
@media print {
  .phccloud-page {
    page: phccloud-page; /* 绑定唯一命名 */
  }
  @page phccloud-page {size: A4;margin: 0;}
  body {width: 210mm;height: 297mm;margin: 0 auto;background: white;}
  .no-print { display: none; } /* 隐藏非打印元素 */
}
.page {width: 210mm;height: 297mm;text-align: center;margin:0 auto;padding-top:30px;padding-left:25px;padding-right:25px;overflow: hidden;position: relative;PAGE-BREAK-AFTER: always;background: #fff;font-size: 15px;}

</style>

